"use client";

import dynamic from "next/dynamic";
import type { ChartsBlock } from "@mw/shared/payload-types";

const BlockCharts = dynamic(() => import("./BlockCharts").then(mod => mod.BlockCharts));

export const BlockChartsWrapper = (props: ChartsBlock) => {
  return <BlockCharts {...props} />;
};
